/* components in here are very small */

/* eslint-disable react/display-name */
import { Typography } from "@mui/material";
import { TagToComponentMap } from "nwon-html-to-react";
import { mappedHeadlines } from "../mappedHeadlines";
import { mappedDivs } from "./mappedDivs";
import { mappedFigures } from "./mappedFigures";
import { mappedLinks } from "./mappedLinks";
import { mappedParagraphs } from "./mappedParagraphs";
import { mappedUnorderedLists } from "./mappedUnorderedLists";

const commonElements: TagToComponentMap = {
  p: (props) => (
    <Typography variant="body1" className="marginBottom">
      {props.children}
    </Typography>
  ),
  ...mappedDivs,
  ...mappedFigures,
  ...mappedLinks,
  ...mappedParagraphs,
  ...mappedUnorderedLists,
};

export const mapGenericContent: TagToComponentMap = {
  ...commonElements,
  ...mappedHeadlines(),
};
